import React, { useEffect } from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { InteractionStatus } from "@azure/msal-browser";
import Button from "@mui/material/Button";
import { loginRequest } from "../auth/authConfig";

const LoginPage: React.FC = () => {
  const { instance, inProgress } = useMsal();
  const istAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();

  const login = () => {
    if (
      inProgress !== InteractionStatus.Startup &&
      inProgress !== InteractionStatus.HandleRedirect
    ) {
      instance.loginRedirect(loginRequest);
    }
  };

  useEffect(() => {
    if (istAuthenticated) {
      navigate("/");
    }
  });

  return (
    <div className="h-screen flex justify-center items-center bg-gray-100">
      <div className="text-center space-y-6 bg-white shadow-md px-10 py-10">
        <h2 className="text-4xl">{process.env.REACT_APP_APP_DISPLAY_NAME}</h2>
        <Button variant="contained" size="large" onClick={login}>
          Sign In with Microsoft
        </Button>
      </div>
    </div>
  );
};

export default LoginPage;
